import i18n from "@/i18n";

import { CustomFilter } from "@/types/custom-filter";

import { FalconComplaintPositiveDecision } from "@/enums/falcon/complaints/falcon-complaint-positive-decision.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint positive decision filter
 */
export const falconComplaintPositiveDecisionFilter: CustomFilter = {
  falconComplaintPositiveDecision(value: any): string {
    value = value.toString() as FalconComplaintPositiveDecision;
    if (value === FalconComplaintPositiveDecision.Refund) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintPositiveDecisionRefundText
      );
    } else if (value === FalconComplaintPositiveDecision.Exchange) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintPositiveDecisionExchangeText
      );
    } else {
      value = "";
    }
    return value;
  }
};
